import { render, staticRenderFns } from "./gradeList.vue?vue&type=template&id=4180c2d3&scoped=true"
import script from "./gradeList.vue?vue&type=script&lang=js"
export * from "./gradeList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/enroll/gradeList.css?vue&type=style&index=0&id=4180c2d3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4180c2d3",
  null
  
)

export default component.exports